import { VehicleMaintenanceReminderDto, VehicleMaintenanceReminderQueryParameters } from "../models/vehicle/vehicleMaintenanceReminder";
import { apiCall, ApiResponse } from "./apiClient";

export const saveVehicleMaintenanceReminder = async(
    vehicleMaintenanceReminder: VehicleMaintenanceReminderDto,
    signal?: AbortSignal): Promise<ApiResponse<VehicleMaintenanceReminderDto>> => {

    const isNew = !vehicleMaintenanceReminder.id ? true : false;

    return apiCall<VehicleMaintenanceReminderDto>(
        "vehiclemaintenancereminder",
        isNew ? "POST" : "PUT",
        vehicleMaintenanceReminder,
        signal);
};

export const getVehicleMaintenanceReminders = async(
    qsp: VehicleMaintenanceReminderQueryParameters, // TODO
    signal?: AbortSignal) => {

    const response = await apiCall<VehicleMaintenanceReminderDto[]>(
        "vehiclemaintenancereminder",
        "GET",
        qsp,
        signal);

    return response.data;
};

export const approveVehicleMaintenanceReminder = async (
    vehicleMaintenanceId: string,
    signal?: AbortSignal): Promise<ApiResponse<VehicleMaintenanceReminderDto>> => {

    return apiCall<VehicleMaintenanceReminderDto>(
        `vehiclemaintenancereminder/approve/${vehicleMaintenanceId}`,
        "POST",
        undefined,
        signal);
};

export const deleteVehicleMaintenanceReminder = async (
    vehicleMaintenanceReminderId: string,
    signal?: AbortSignal): Promise<ApiResponse<void>> => {

    return apiCall<void>(
        `vehiclemaintenancereminder/${vehicleMaintenanceReminderId}`,
        "DELETE",
        undefined,
        signal);
};
